import React, { lazy, Suspense } from 'react';
import { Switch } from 'react-router';

import { GuardedRoute } from 'core/routing';
import { PageLoader } from 'shared/components/elements/Loader';

const App = lazy(() => import('app/AppContainer'));

export const Routes = () => (
  <Suspense fallback={<PageLoader />}>
    <Switch>
      <GuardedRoute component={App} path='/' />
    </Switch>
  </Suspense>
);
